<template>
    <div class="container h-full">
        <div class="overflow-hidden rounded-md">
            <div class="px-4 py-5 space-y-6 bg-white">
                <!-- key -->
                <div>
                    <label class="block mb-2 text-sm font-medium text-gray-700 dark:text-gray-300"> Key* </label>
                    <div class="space-y-1">
                        <t-input
                            v-model="form.key"
                            type="text"
                            placeholder="Key"
                            :disabled="true"
                            required
                            :variant="errors('key') ? 'danger' : ''"
                        />
                        <p
                            v-if="errors('key')"
                            class="text-xs text-red-500"
                        >
                            {{ errors('key') }}
                        </p>
                    </div>
                </div>

                <!-- value -->
                <div>
                    <label class="block mb-2 text-sm font-medium text-gray-700 dark:text-gray-300"> Value* </label>
                    <div class="space-y-1">
                        <t-input
                            v-model="form.value"
                            type="text"
                            placeholder="Value"
                            required
                            :variant="errors('value') ? 'danger' : ''"
                        />
                        <p
                            v-if="errors('value')"
                            class="text-xs text-red-500"
                        >
                            {{ errors('value') }}
                        </p>
                    </div>
                </div>
            </div>

            <div class="px-4 py-3 text-right bg-gray-50">
                <t-button
                    variant="success"
                    :disabled="processing"
                    size="sm"
                    @click="submitForm"
                >
                    {{ processing ? 'Saving...' : 'Save' }}
                </t-button>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'ConfigForm',

        props: {
            editData: {
                type: Object,
                default: null,
            },
        },

        data() {
            return {
                form: {
                    key: null,
                    value: null,
                },
                processing: false,
            };
        },

        async mounted() {
            if (this.editData) {
                this.form.key = this.editData.key;

                let currentUserId = null;
                if (this.isWholesaler) {
                    currentUserId = this.$page.props.user.id;
                }
                this.form.value = this.editData.values.find((value) => value.user_id === currentUserId)?.value;
            }
        },

        methods: {
            submitForm() {
                this.processing = true;

                const payload = this.buildPayload();
                if (this.isAdmin) {
                    const condition = !!this.editData.values.find((value) => value.user_id === null);
                    condition ? this.update(payload) : this.save(payload);
                } else {
                    const condition = !!this.editData.values.find(
                        (value) => value.user_id === this.$page.props.user.id,
                    );
                    condition ? this.update(payload) : this.save(payload);
                }
            },

            buildPayload() {
                const formData = new FormData();
                if (this.form.value) {
                    formData.append('value', this.form.value);
                }

                if (this.isAdmin) {
                    const condition = !!this.editData.values.find((value) => value.user_id === null);
                    if (condition) {
                        formData.append('_method', 'PUT');
                    } else {
                        formData.append('common_id', this.editData.id);
                    }
                } else {
                    const condition = !!this.editData.values.find(
                        (value) => value.user_id === this.$page.props.user.id,
                    );
                    if (condition) {
                        formData.append('_method', 'PUT');
                    } else {
                        formData.append('common_id', this.editData.id);
                    }
                }
                return formData;
            },

            save(payload) {
                this.$inertia.post(route('commons.value.store'), payload, {
                    onSuccess: () => {
                        this.processing = false;
                        this.$emit('transactionComplete');
                    },
                });
            },

            update(payload) {
                let commonValue;
                if (this.isAdmin) {
                    commonValue = this.editData.values.find((value) => value.user_id === null);
                } else {
                    commonValue = this.editData.values.find((value) => value.user_id === this.$page.props.user.id);
                }
                this.$inertia.post(route('commons.value.update', commonValue.id), payload, {
                    onSuccess: () => {
                        this.processing = false;
                        this.$emit('transactionComplete');
                    },
                });
            },
        },
    };
</script>
